module.exports = __webpack_public_path__ + "img/question.1a1131fc.svg";